import { ReactNode, ReactElement } from 'react';
import {
  render, renderHook, RenderOptions, RenderHookOptions, fireEvent,
} from '@testing-library/react';
import { HashRouter } from 'react-router-dom';
import { Theme } from '../src/styling';
import { lightTheme } from '../src/styling/Styles';

type ElementType = Element | Node | Document | Window | null;

export const defaultTestTheme = lightTheme;

// Mock XHR as axios will use XHR as default request adapter
export function createMockXhr(overrides: Partial<XMLHttpRequest> = {}) {
  const xhr = new window.XMLHttpRequest();
  Object.entries(overrides).forEach(([entry, value]) => {
    Object.defineProperty(xhr, entry, { value, writable: true });
  });
  xhr.send = jest.fn(() => { (xhr.onloadend as any)(); });
  return xhr;
}

export function WrapedRender({ children }: {children: ReactNode}) {
  return (
    <HashRouter>
      <Theme>
        {children}
      </Theme>
    </HashRouter>
  );
}

const customRender = (
  ui: ReactElement,
  options?: Omit<RenderOptions, 'wrapper'>,
) => render(ui, { wrapper: WrapedRender, ...options });

const customRenderHook = <Result, Props>(
  renderHookRender: (initialProps: Props) => Result,
  options?: RenderHookOptions<Props>,
) => renderHook(renderHookRender, { wrapper: WrapedRender, ...options });

const customFireEvent = {
  ...fireEvent,
  change: (
    element: ElementType,
    options?: {} | undefined,
  ) => (element ? fireEvent.change(element, options) : false),
  click: (
    element: ElementType,
    options?: {} | undefined,
  ) => (element ? fireEvent.click(element, options) : false),
};

export * from '@testing-library/react';
export { customRender as render };
export { customRenderHook as renderHook };
export { customFireEvent as fireEvent };
